/**
 * Created by DSadler on 25/04/2017.
 */
import React, {Component} from 'react';
import BuildingBlocks from "./BuildingBlocks";
import {getContentItemDefCategories, getContentDefinitions} from "../../../state/config/selectors";
import {connect} from "react-redux";
import {setUiDraggedContentItem, setUiSelectedContentItem} from "../../../state/ui/actions";
import {DATA_TRANSFER_TYPE, DRAG_TYPE} from "../../../dragDropDefinitions";

class BuildingBlocksContainer extends Component {
  constructor(props) {
    super(props);

    this.handleDrag = this.handleDrag.bind(this);
    this.handleDragEnd = this.handleDragEnd.bind(this);
  }
  handleDrag(e, contentConfig) {
    e.stopPropagation();
    //e.preventDefault();
    this.props.dispatch(setUiSelectedContentItem(null));
    this.props.dispatch(setUiDraggedContentItem(contentConfig));
    e.dataTransfer.setData(DATA_TRANSFER_TYPE.DRAG_TYPE, DRAG_TYPE.NEW_ITEM);
  };
  handleDragEnd(e) {
    e.stopPropagation();
    e.preventDefault();
  };
  render() {
    return (
      <BuildingBlocks
        contentItemDefs={this.props.contentItemDefs}
        contentItemDefCategories={this.props.contentItemDefCategories}
        handleDrag={this.handleDrag}
        handleDragEnd={this.handleDragEnd}
      />
    );
  }
}

function mapStateToProps(state) {
  let contentItemDefs = getContentDefinitions(state);
  let contentItemDefCategories = getContentItemDefCategories(state);
  return {
    contentItemDefs,
    contentItemDefCategories,
  }
}

function mapDispatchToProps(dispatch) {
  return {dispatch};
}

export default connect(mapStateToProps, mapDispatchToProps)(BuildingBlocksContainer);


// WEBPACK FOOTER //
// ./src/App/Editor/components/ui/ToolBox/BuildingBlocksContainer.js